import { useContext } from 'react';

import Checkbox from '@ingka/checkbox';
import Text from '@ingka/text';
import { t } from '@onlinepayments/payments-library';

import { OrderDetailsContext } from '../../../OrderDetailsContext';

export const SaferHomesCheckbox = ({ onChange }: { onChange: (value: boolean) => void }) => {
  const { saferHomesState } = useContext(OrderDetailsContext);

  return (
    <>
      <Text className="mb-75" textStyle="Heading.S">
        {t('payment.safer_homes.title')}
      </Text>
      <Checkbox
        id="safer-homes-checkbox"
        value="safer-homes-checkbox"
        onChange={(event) => onChange(event.target.checked)}
        label={saferHomesState.saferHomesText}
      />
    </>
  );
};
